module.exports = __webpack_public_path__ + "static/img/7.134408b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/3/1/sp/7.png
// module id = 06Vt
// module chunks = 0